import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useMutation } from 'react-query'
import { BrandPlan, BrandPlanTacticContents } from 'types'
import { useCurrentWorkspaceId } from './useCurrentWorkspaceId'

export interface UpgradeBrandPlanParams {
  payment_method_id?: string
  price_id: string
  promotion_code?: string
  growth_goals_input?: string
  key_dates_input?: string
  instagram_contents?: BrandPlanTacticContents
  facebook_contents?: BrandPlanTacticContents
  linkedin_contents?: BrandPlanTacticContents
  twitter_contents?: BrandPlanTacticContents
  tiktok_contents?: BrandPlanTacticContents
  seo_contents?: BrandPlanTacticContents
  email_contents?: BrandPlanTacticContents
  youtube_contents?: BrandPlanTacticContents
  start_date?: string
  strategy?: { type: string }
  tactics?: string[]
  crosspost_frequency?: string
  crosspost_contents?: any[]
  video_crosspost_contents?: any[]
  selected_blog_platform?: string
  selected_email_platform?: string
}

const upgradeBrandPlan = async ({
  workspaceId,
  params,
  signal,
}: {
  workspaceId: number
  params: UpgradeBrandPlanParams
  signal?: AbortSignal
}) => {
  const res = await sendToApi<{ brand_plan: BrandPlan }>(`/w/${workspaceId}/brand_plans/upgrade`, {
    body: params,
    method: 'POST',
    signal,
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data.brand_plan
}

export const useUpgradeBrandPlan = () => {
  const workspaceId = useCurrentWorkspaceId()

  return useMutation((params: UpgradeBrandPlanParams) => upgradeBrandPlan({ workspaceId, params }))
}
